export default __webpack_public_path__ + "static/media/searchexprtbg.686c00bc.svg";